import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfc0c1e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("p", null, "提供情報の送信が完了しました。 "),
  /*#__PURE__*/_createElementVNode("p", null, "公開調査にご協力いただき、誠にありがとうございました。")
], -1))
const _hoisted_4 = { class: "area-toButton" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 国立国会図書館デジタルコレクション ホームページ ")
const _hoisted_6 = { class: "area-toButton" }
const _hoisted_7 = {
  href: "https://www.ndl.go.jp/",
  class: "button-toHP"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 国立国会図書館 ホームページ ")
const _hoisted_9 = { class: "navigation-button" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 検索結果に戻る ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToPageTop = _resolveComponent("ToPageTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "button-toTop"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DssIcon, { icon: 'arrow-right' }),
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_component_DssIcon, { icon: 'arrow-right' }),
            _hoisted_8
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: {
        path: '/openinq/search',
        query: _ctx.openinqSearch,
        force: true
      },
        class: "button-back"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DssIcon, {
            icon: "arrow-left",
            style: {"font-size":"18px"}
          }),
          _hoisted_10
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_ToPageTop)
  ], 64))
}